// BroadcastList.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import DropDownIcon from '../../img/ic_dropdown_w.svg';
import MessageCard from '../container/MessageCard.js';
import { InfiniteScroller, ScrollItem } from './InfiniteScroller.jsx';
import { ProfileListType } from '../resource/profileConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export class BroadcastList extends React.PureComponent {
  componentDidMount() {
    if (this.selectedItem) {
      this.selectedItem.scrollIntoView({ inline: 'center' });
    }
  }

  render() {
    const {
      feedNameWithQuery,
      username,
      postCount,
      nextPage,
      itemIds,
      selectedMessageId,
      isNextPageFetching,
      isShortVideo,
      fetchFeeds,
      closeBroadcastList,
      t,
    } = this.props;

    const activeIndex = itemIds.indexOf(selectedMessageId);

    return (
      <StyledBroadcastList>
        <BroadcastListHead>
          <BroadcastListTitle>
            {t(
              isShortVideo
                ? 'cp_short_video_list_title'
                : 'broadcast_list_title',
              { username, ns: TranslationNamespace.POST }
            )}
            {`(${activeIndex !== -1 ? `${activeIndex + 1}/` : ''}${postCount})`}
          </BroadcastListTitle>
          <BroadcastListCloseButton
            onClick={() => closeBroadcastList(selectedMessageId)}
          >
            <img src={DropDownIcon} />
          </BroadcastListCloseButton>
        </BroadcastListHead>
        <BroadcastListBody>
          <InfiniteScroller
            axis="x"
            useWindow={false}
            pageStart={1}
            hasMore={nextPage != null}
            loadMore={() =>
              fetchFeeds({
                page: nextPage,
                type: feedNameWithQuery,
              })
            }
            isFetching={isNextPageFetching}
            threshold={100}
          >
            <BroadcastListWrapper>
              <ScrollItem loader={<MessageCardWrapper />}>
                {itemIds.map(this.renderItem)}
              </ScrollItem>
            </BroadcastListWrapper>
          </InfiniteScroller>
        </BroadcastListBody>
      </StyledBroadcastList>
    );
  }

  renderItem = (itemId, index) => {
    const {
      selectedMessageId,
      itemIds,
      userId,
      isShortVideo,
      feedNameWithQuery,
    } = this.props;

    const activeIndex = itemIds.indexOf(selectedMessageId);
    return (
      <MessageCardWrapper
        key={itemId}
        ref={ref => {
          activeIndex === index ? (this.selectedItem = ref) : null;
        }}
        isSelected={activeIndex === index}
      >
        <MessageCard
          id={itemId}
          categoryId={feedNameWithQuery}
          itemIndexInCategory={index}
          shouldWrapLink
          shouldTrackEvent
          shouldReplace
          listPath={
            isShortVideo
              ? ['outbox', ProfileListType.SHORT, userId]
              : ['outbox', ProfileListType.STORY, userId]
          }
        />
      </MessageCardWrapper>
    );
  };
}

BroadcastList.propTypes = {
  isNextPageFetching: PropTypes.bool,
  isShortVideo: PropTypes.bool,
  feedNameWithQuery: PropTypes.string,
  username: PropTypes.string,
  userId: PropTypes.string,
  itemIds: PropTypes.arrayOf(PropTypes.string),
  nextPage: PropTypes.number,
  postCount: PropTypes.number,
  selectedMessageId: PropTypes.string,
  closeBroadcastList: PropTypes.func,
  fetchFeeds: PropTypes.func,
  t: PropTypes.func.isRequired,
};

BroadcastList.defaultProps = {
  isNextPageFetching: false,
  isShortVideo: false,
  feedNameWithQuery: null,
  username: '',
  userId: '',
  nextPage: null,
  itemIds: [],
  postCount: null,
  selectedMessageId: null,
  closeBroadcastList: () => null,
  fetchFeeds: () => null,
};

const StyledBroadcastList = styled.div`
  position: relative;
  width: 100%;
  pointer-events: auto;
`;

const BroadcastListHead = styled.div`
  position: relative;
  width: 100%;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(200, 200, 200, 0.5);
`;

const BroadcastListTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: rgb(255, 255, 255);
`;

const BroadcastListCloseButton = styled.button`
  cursor: pointer;
  width: 20px;
  height: 20px;
  outline: 0;
  border: 0;
  padding: 0;
  background: none;

  & > img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const BroadcastListBody = styled.div`
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  width: 100%;
  padding: 16px 0 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BroadcastListWrapper = styled.div`
  display: flex;
  padding: 0 8px;
`;

const MessageCardWrapper = styled.div`
  cursor: pointer;
  flex: none;
  width: 122px;
  height: 170px;
  margin-left: 8px;
  border-radius: 4px;
  ${({ isSelected }) => (isSelected ? 'border: 1px solid #fff;' : '')}
  :first-of-type {
    margin-left: 0px;
  }
  :last-of-type {
    margin-right: 8px;
  }
`;

export default withTranslation()(BroadcastList);
